import { useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader"; 
import heroBg from "../../images/home/header-background.jpg";
import "./Home.css";

import axiosClient from "../../api/axios";

export default function Hero() {

  const [homeIntro, setHomeIntro] = useState(null);
  const [loadingHomeIntro, setLoadingHomeIntro] = useState(true);

  useEffect(() => {
    const fetchHomeIntro = async () => {
      try {
        const response = await axiosClient.get(`/api/home-introduction/`);
        setHomeIntro(response.data.data);
      } catch (error) {
        console.error("Failed to fetch study:", error);
      } finally {
        setLoadingHomeIntro(false);
      }
    };

    fetchHomeIntro();
  }, []);


  if (loadingHomeIntro) {
    return (
      <section
        className="hero-section pt-100 background-img"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="white" size={80} />
      </section>
    );
  }



  return (
    <>
      <section
        className="hero-section pt-100 background-img"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between header-cntr">
            <div className="col-md-6 col-lg-6">
              <div className="hero-content-left text-white mt-5">
                <h1 className="text-white mb-5">
                  <span>{homeIntro?.title}</span>
                </h1>

                {homeIntro?.subtitles.map((data) => (
                  <div key={data.id} className="single-feature">
                    <div className="d-flex align-items-center mb-2">
                      <span className={`${data.icon} rounded mr-3 icon`}></span>
                      <h5 className="mb-0 text-white">{data.title}</h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6 col-lg-5">
              <div className="hero-animation-img">
                <img
                  src={homeIntro?.image_url}
                  alt="Advanced Research"
                  className="hero-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
